






import { Component, Vue, Prop} from "vue-property-decorator";

@Component({})

export default class TruckIcon extends Vue {
  /* Props */
  @Prop({ default: "#FFFFFF" })
  public color!: string;
}

